import { axiosInstance } from "./";

const getLocationsList = async (params) =>
  await axiosInstance.get("/locations", { params });

const deleteLocation = async (id) =>
  await axiosInstance.delete(`/locations/${id}`);
export { getLocationsList, deleteLocation };
